import { PrimaryButton } from '@designsforhealth/dfh-react-components'
import SliderImport from 'react-slick'
import styled from 'styled-components'

import Background from '../../../../../../img/rewards_onboarding/modal/background.png'

export const Slider = styled(SliderImport)`
  position: relative;
  width: 100%;
  height: 100%;

  .slick-track {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
  }

  .slick-slide {
    height: auto;
  }

  .slick-slide > div {
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
    width: 100%;
  }

  .slick-prev {
    left: 0;
    background-color: ${({ theme }) => theme.colors.grayscale.white};
    &:hover {
      opacity: 0.9;
    }
  }

  .slick-next {
    right: 0;
    background-color: ${({ theme }) => theme.colors.blackPearlBlue.shade700} !important;
    &:hover {
      opacity: 0.8;
    }
  }

  .slick-prev,
  .slick-next {
    z-index: 1000 !important;
    color: ${({ theme }) => theme.colors.grayscale.black};
    padding: 25px;
    border-radius: 50%;
    box-shadow: 4px 4px 15px ${({ theme }) => theme.colors.coolGray.cool600};
    top: 96%;
  }

  .slick-prev:before,
  .slick-next:before {
    display: none !important;
  }

  .slick-dots {
    bottom: 12px !important;
    width: 50%;
    left: 50%;
    transform: translateX(-50%);
  }

  .slick-dots li button:before {
    font-size: 10px;
    color: ${({ theme }) => theme.colors.blackPearlBlue.shade600};
  }

  .slick-dots .slick-active button:before {
    font-size: 12px;
  }
  .slick-dots li {
    margin: 0;
  }
  @media (min-width: 425px) {
    .slick-dots .slick-active button:before {
      font-size: 20px;
    }
    .slick-dots li button:before {
      font-size: 15px;
      margin: 0;
    }
    .slick-dots li {
      margin: 0 5px;
    }
  }
`

export const ArrowContainer = styled.div<{ hide?: boolean }>`
  display: ${({ hide }) => (hide ? 'hidden' : 'flex !important')};
  align-items: center !important;
  justify-content: center !important;
`

export const Content = styled.div<{ currentSlide: number }>`
  position: relative;
  width: 95vw;
  height: 95%;
  color: ${({ theme }) => theme.colors.brand.blue};
  padding: 48px;
  border-radius: 24px;
  overflow: hidden;
  background: ${({ currentSlide }) => (currentSlide !== 0 ? `url(${Background})` : `url('')`)};
  background-size: cover;
  background-color: ${({ theme }) => theme.colors.grayscale.white};

  @media (min-width: 768px) {
    width: 718px;
    max-height: 760px;
  }
`

export const Logo = styled.img`
  margin-bottom: 32px;
`

export const ImageWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  border-radius: 24px;
  clip-path: border-box;
  width: 100%;
`

export const Image = styled.img<{ margin?: string; width?: string; position?: string }>`
  margin: ${({ margin }) => (margin ? margin : '0')};
  width: ${({ width }) => (width === '278px' ? '238px' : width ? width : 'unset')};
  object-fit: cover;
  object-position: ${({ position }) => (position ? position : 'center')};

  @media (min-width: 768px) {
    object-position: unset;
  }
`

export const Header = styled.h3`
  color: inherit;
  font-family: Gotham, sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 28.8px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin-bottom: 16px;

  @media (min-width: 768px) {
    font-size: 32px;
    line-height: 38.4px;
    margin-bottom: 32px;
  }
`

export const SubHeader = styled.h4`
  font-family: Gotham, sans-serif;
  font-size: 28px;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`

export const Text = styled.p`
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: Roboto, sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 23.44px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 2px 0 44px;
  max-width: 536px;
`

export const CloseModal = styled.button`
  position: absolute;
  top: 25px;
  right: 25px;
  display: flex;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 10000;

  svg {
    width: 24px;
    height: 24px;
  }
`

export const Button = styled(PrimaryButton)`
  display: flex;
  align-items: center;
  align-self: flex-end;
  justify-self: flex-end;
  background: ${({ theme }) => theme.colors.blackPearlBlue.shade700};
  font-size: 18px;
  font-weight: 500;
  z-index: 1000 !important;
  position: absolute;
  right: 0;
  bottom: 0;

  svg {
    margin-left: 8px;
    width: 14px;
    height: 14px;
  }
`
